<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" [style]="enableError? 'margin: 1% 2% 0% 2%;':  'margin: 1% 2% 4% 2%;'">
    <br>
    <div class="row">
        <div class="col-12">
            <div class="row" style="margin:0">
                <div class="col-1">
                    <label class="catlabel">E/W<span style="color:#ff0000">*</span></label>
                </div>
                <div class="col-9 custom_row_col">
                    <select class="ew_dropdown" [(ngModel)]="selectedEWConfigurationId">
                        <option *ngFor="let ewconfiguration of ewconfigurationList" [value]="ewconfiguration.id">
                            {{ewconfiguration.value}}
                        </option>
                    </select>
                </div>
            </div>

        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Route</label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedRouteId" (change)="routeChange()" [disabled]="routeList.length<=1">
                        <option *ngFor="let route of routeList" [value]="route.id">
                            {{route.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Route Date</label>
                <span class="content">
                    <input type="date" class="category" onkeypress="return false" (change)="dateChange();"
                        [(ngModel)]="routedate">
                </span>

            </div>
        </div>

        <div class="col-12">
            <div class="row" style="margin:0;">
                <div class="col-1">
                    <label class="catlabel">Domiciles</label>
                </div>
                <div class="col-10 custom_row_col" style="height: 206px;overflow:overlay;">
                    <div class="row">
                        <div class="col-3" *ngFor="let domicile of domicileList">
                            <input type="checkbox" id="domicile.id" [(ngModel)]="domicile.isChecked"
                                (change)="domicileListChange();" style="width: 1.2em;height:1.2em">
                            <label for="domicile.id" class="domicile_label">{{domicile.value}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>